const DEV_ENV_PREFIX = 'VITE_';

let ENVS: any = {};
let initiated = false;

export const initEnv = () => {
  if (initiated) return;
  initiated = true;
  // Store environments variables
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ENVS = (window as any).__environment_variables__ ?? {};
  // Clean environments variables
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (window as any).__environment_variables__ = {};
}

const getUrl = (str: string | undefined): string | undefined => {
  if (!str) return undefined;
  let url;
  try {
    const urlObj = new URL(str);
    url = urlObj.href;
  } catch {}
  return url;
}

const getEnv = (key: string): string | undefined => {
  let result: string | undefined;
  if (import.meta.env.DEV) {
    result = import.meta.env[`${DEV_ENV_PREFIX}${key}`];
    if (result !== undefined) {
      return result;
    }
  }
  return ENVS[key];
}

export const getEnvApiUrl = () : string | undefined => {
  return getUrl(getEnv('API_URL'));
}

export const getEnvApiUrls = () : {[hostname: string]: string | undefined} => {
  const str = getEnv('API_URLS');
  if (!str) return {};
  let json: {[hostname: string]: string | undefined} = {};
  try {
    const parsed = JSON.parse(str);
    Object.keys(parsed).forEach((k) => {
      const value = parsed[k];
      if (typeof value === "string") {
        json[k] = getUrl(value);
      }
    })
  } catch {}
  return json;
}

export const getOrgIDFromEnv = () : string | undefined => {
  return getEnv('ORG_ID');
}

export const getEnvApiMode = () : string | undefined => {
  return getEnv('API_MODE')
}

export const getEnvOAuth2ClientId = () : string | undefined => {
  return getEnv('OAUTH2_CLIENT_ID')
}

export const getEnvSettings = () : string | undefined => {
  return getEnv('SETTINGS');
}

/**
 * Co-branding logo shown next to ours in the top bar. Same shape as API_URLS:
 * the keys are hostname patterns, so a single deployment can serve several
 * clients ({"prepa-connect\\.": "https://…/logo.png"}). An empty key matches
 * every hostname, which makes it a default. Relative paths are allowed, so a
 * logo bundled with the app works too.
 */
export const getEnvClientLogos = () : {[hostname: string]: string | undefined} => {
  const str = getEnv('CLIENT_LOGOS');
  if (!str) return {};
  const json: {[hostname: string]: string | undefined} = {};
  try {
    const parsed = JSON.parse(str);
    Object.keys(parsed).forEach((k) => {
      const value = parsed[k];
      if (typeof value === "string" && value) json[k] = value;
    });
  } catch {}
  return json;
}

/** The client logo for the hostname being served, CLIENT_LOGO as the fallback. */
export const getEnvClientLogo = (hostname: string = window.location.hostname) : string | undefined => {
  const logos = getEnvClientLogos();
  let result: string | undefined;
  Object.keys(logos).forEach((pattern) => {
    // Same matching as API_URLS: a pattern, last match wins.
    if (hostname.match(pattern)?.length) result = logos[pattern];
  });
  return result ?? getEnv('CLIENT_LOGO');
}
